module.exports = __webpack_public_path__ + "h5/img/pay-demo.5927aba2.jpg";